const toRegEx = (pattern?: string) => {
  if (!pattern) {
    return undefined;
  } else if (pattern.trim() === "*") {
    return /.*/;
  } else {
    return new RegExp(pattern);
  }
};

export const validateRegExMatch = (
  value: any,
  pattern?: string,
  patternDescription?: string,
  patternExample?: string,
) => {
  const regEx = toRegEx(pattern);
  if (regEx) {
    const matchPart = (value as string).match(regEx);
    const match = matchPart && value === matchPart[0];
    if (!match) {
      let errMsg = `Value ${value} is not allowed`;
      if (patternDescription) errMsg = `${errMsg}, must be: "${patternDescription}"`;
      if (patternExample) errMsg = `${errMsg} (e.g. "${patternExample}")`;
      throw new Error(errMsg);
    }
  }
};
